module.exports = __webpack_public_path__ + "static/mobile-optimized-design-97ed6aacade9feb3c442e991479b4c23.png";